import { GlobalUtilityService } from '@AppCore/services/global-utility.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { LocalStorageDataModel } from '@AppCore/constants/local-storage-data-model';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { APIResponse } from '@AppRoot/shared/models/api-response.interface';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
})
export class RegisterComponent {
  registerForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.email]),
    password: new FormControl('', [Validators.minLength(6)]),
    first_name: new FormControl('', [
      Validators.required,
      Validators.pattern('^[a-zA-Z \s]*$'),
    ]),
    last_name: new FormControl('', [Validators.pattern('^[a-zA-Z \s]*$')]),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]{5}[0-9]{5}$'),
    ]),
  });

  verifyRegistrationForm: FormGroup = new FormGroup({
    username: new FormControl(''),
    otp: new FormControl('', [
      Validators.required,
      Validators.pattern('^[0-9]*$'),
    ]),
  });

  showVerifyRegistrationDialog: boolean = false;

  constructor(
    private _route: Router,
    private _authService: AuthService,
    private globalUtilityService: GlobalUtilityService
  ) {}

  ngOnInit() {
    if (
      this.globalUtilityService.getDataFromLocalStorage(
        LocalStorageDataModel.AUTH_KEY
      )
    ) {
      this._route.navigate(['/']);
    }
  }

  register() {
    console.log(this.registerForm.invalid);
    if (this.registerForm.invalid) {
      return;
    }

    const email = this.registerForm.get('email')?.value;
    const password = this.registerForm.get('password')?.value;
    const first_name = this.registerForm.get('first_name')?.value;
    const last_name = this.registerForm.get('last_name')?.value;
    const phone = this.registerForm.get('phone')?.value;
    this.globalUtilityService.showLoader();
    this._authService.register(this.registerForm.value).subscribe({
      next: (data: any) => {
        this.globalUtilityService.showToast('success', data.message);
        this.globalUtilityService.hideLoader();
        this.showVerifyRegistrationDialog = true;
      },
      error: (error: any) => {
        this.globalUtilityService.hideLoader();
        this.globalUtilityService.showToast('Error', error.message);
      },
    });
  }

  verifyRegistration() {
    if (this.verifyRegistrationForm.invalid) {
      return;
    }

    this.verifyRegistrationForm
      .get('username')
      ?.setValue(this.registerForm.get('email')?.value);

    const otp = this.verifyRegistrationForm.get('otp')?.value;
    // const username = this.verifyRegistrationForm.get('username')?.value;
    this.globalUtilityService.showLoader();
    this._authService.sendOtp(otp).subscribe({
      next: (res: APIResponse) => {
        if (res.data.success) {
          this.showVerifyRegistrationDialog = true;
        }
        this.globalUtilityService.hideLoader();
      },
      error: (error: any) => {
        this.globalUtilityService.hideLoader();
        this.globalUtilityService.showToast('Error', error.message);
      },
    });
  }

  get email() {
    return this.registerForm.get('email');
  }

  get firstName() {
    return this.registerForm.get('first_name');
  }

  get lastName() {
    return this.registerForm.get('last_name');
  }

  get phoneNumber() {
    return this.registerForm.get('phone');
  }
}
